import { Router } from 'pjax';
import form from './form.js';

Router.get('price/:any', form);
